import { c as _c } from "react/compiler-runtime";
import React from "react";
import UnifiedWavesList from "./UnifiedWavesList";
import { useMyStream } from "@/contexts/wave/MyStreamContext";
interface BrainLeftSidebarWavesProps {
  readonly scrollContainerRef: React.RefObject<HTMLDivElement | null>;
}
const BrainLeftSidebarWaves: React.FC<BrainLeftSidebarWavesProps> = t0 => {
  const $ = _c(10);
  const {
    scrollContainerRef
  } = t0;
  const {
    waves,
    registerWave
  } = useMyStream();
  let t1;
  if ($[0] !== waves) {
    t1 = () => {
      if (waves.hasNextPage && !waves.isFetchingNextPage && !waves.isFetching) {
        waves.fetchNextPage();
      }
    };
    $[0] = waves;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onNextPage = t1;
  let t2;
  if ($[2] !== onNextPage || $[3] !== registerWave || $[4] !== scrollContainerRef || $[5] !== waves.hasNextPage || $[6] !== waves.isFetching || $[7] !== waves.isFetchingNextPage || $[8] !== waves.list) {
    t2 = <UnifiedWavesList waves={waves.list} fetchNextPage={onNextPage} hasNextPage={waves.hasNextPage} isFetching={waves.isFetching} isFetchingNextPage={waves.isFetchingNextPage} onHover={registerWave} scrollContainerRef={scrollContainerRef} />;
    $[2] = onNextPage;
    $[3] = registerWave;
    $[4] = scrollContainerRef;
    $[5] = waves.hasNextPage;
    $[6] = waves.isFetching;
    $[7] = waves.isFetchingNextPage;
    $[8] = waves.list;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
export default BrainLeftSidebarWaves;